import { render } from "./add-payment-method.vue?vue&type=template&id=66e7e388&scoped=true"
import script from "./add-payment-method.vue?vue&type=script&lang=js"
export * from "./add-payment-method.vue?vue&type=script&lang=js"

import "./add-payment-method.vue?vue&type=style&index=0&id=66e7e388&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e7e388"]])

export default __exports__